import React, { Component } from 'react';
import Modal from 'react-modal';

import store from '../../../store/configureStore';
import { addNotification } from "../../../actions/notificationAction";
import informationApi from "../../../api/informationApi";
import {stepEditStyle} from '../../../config/style';
import {lang} from "../../../config/lang";
import * as UTILS from '../../../config/utils';
import { setTimeout } from 'timers';

/****************************************
    Component for Information Block on Home Page
    @author  IMH003
    @date    2020.05.22
    @version 0.1    
 ******************************************/
class InformationBlock extends Component {
    
    constructor(props) {
        super(props);
        this.business = this.props.business;
        this.id = this.props.id;
        this.state = {
            contentModalIsOpen: false,
            modal_info: {}
        }

        this.ellipsisStyle = this.ellipsisStyle.bind(this);
        this.afterContentModal = this.afterContentModal.bind(this);
        this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
        this.closeContentModal = this.closeContentModal.bind(this);
        this.onClickInformation = this.onClickInformation.bind(this);
        this.getSingleInfo = this.getSingleInfo.bind(this);
    }

    componentWillMount() {
    }

    componentDidMount() {  
        window.addEventListener('resize', this.waitAndEllipsis);
    }
  
    componentDidUpdate() {
        setTimeout(this.ellipsisStyle, 400);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.waitAndEllipsis);
    }

    componentWillReceiveProps(newProps) {
    }

    waitAndEllipsis() {
        setTimeout(this.ellipsisStyle, 800);
    }

    ellipsisStyle() {        
        window.ellipsisMe('#i_' + this.props.business + '_' + this.props.id);
    }

    afterContentModal() {
    
    }

    closeContentModal() {
        this.setState({
            modal_info: {},
            contentModalIsOpen : false
        });
    }

    onClickInformation(id) {   
        this.getSingleInfo(id);
        this.setState({
            contentModalIsOpen : true
        })
    }

    getSingleInfo(id) {
        informationApi.getSingleInfo(id).then((json) => {
            if (json.status === 200) {                
                this.setState({
                    modal_info: json.data
                });
                
            } else {
                store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }            
        })
    }


    render() {

        return (            
            <div>                
                <span onClick={(id)=>this.onClickInformation(this.props.id)} className="popular-category h-100" style={{cursor: 'pointer'}}>
                    <span className="icon"><span className={`icon ${this.props.icon}`}></span></span>
                    <span className="caption mb-2 d-block">&nbsp;</span>              
                    <span className="number ellipsis multiline" 
                        id={`i_${this.props.business}_${this.props.id}`}
                        caption={UTILS.symbolingText(this.props.title)}
                        dangerouslySetInnerHTML={{__html: this.props.title}} />
                </span>
                <Modal
                    isOpen={this.state.contentModalIsOpen}
                    onAfterOpen={this.afterContentModal}
                    onRequestClose={this.closeContentModal}
                    style={stepEditStyle}
                    ariaHideApp = {false}
                    >

                    <div className="custom-modal-header has-back">
                        <button type="button" className="close pull-right" data-dismiss="modal" aria-label="Close"  onClick={() => this.closeContentModal()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h3 className="title" dangerouslySetInnerHTML={{__html: this.state.modal_info.title}} />
                    </div>
                    <div className="custom-modal-content" dangerouslySetInnerHTML={{__html: this.state.modal_info.description }} />
                </Modal>
            </div>
        );
    }
}

export default InformationBlock;
